import type { StackedChartSection } from 'components/StackedChart/types'
import type { YAxisOptions } from 'highcharts'

/**
 * This function checks for any charts having multiple visible Y axes
 * It's intended to be used in the context of stacked charts
 * for adding a bit of extra padding to the right side of the chart
 * in cases when there's a y-axis on the right side.
 * @param content
 * @returns boolean indicating if any chart in the content has multiple Y axes
 */
export const doAnyChartsHaveMultipleYAxes = (content: StackedChartSection[]): boolean => {
  return content.some((section) => {
    return section.items.some((item) => {
      const yAxes: YAxisOptions[] = []

      if (item.chartConfig.yAxis) {
        if (item.chartConfig.yAxis instanceof Array) {
          yAxes.push(...item.chartConfig.yAxis)
        } else {
          yAxes.push(item.chartConfig.yAxis)
        }
      }

      return yAxes.filter((y) => y.visible !== false).length > 1
    })
  })
}
